import { useEffect } from 'react';
import { flushDeliveryNotes } from '../services/deliveryNotes';
import { getToken } from '../services/storage';

// Cada cuánto se mira la cola del DDT mientras la app está abierta. Es barato:
// sin nada pendiente, una lectura de IndexedDB.
const INTERVAL_MS = 60_000;

/**
 * Manda los DDT que quedaron pendientes sin conexión (2026-10-23): al abrir la
 * app, al volver la red, al volver a primer plano y cada minuto. Es su propia
 * cola y su propio ritmo; no se mezcla con el coordinador de detalles y fotos.
 */
export function useDeliveryNoteSync(): void {
  useEffect(() => {
    const flush = () => {
      // Sin sesión el servidor respondería 401: se espera al login.
      if (!getToken() || !navigator.onLine) return;
      void flushDeliveryNotes();
    };
    const onVisible = () => { if (document.visibilityState === 'visible') flush(); };

    flush();
    window.addEventListener('online', flush);
    document.addEventListener('visibilitychange', onVisible);
    const timer = window.setInterval(flush, INTERVAL_MS);
    return () => {
      window.removeEventListener('online', flush);
      document.removeEventListener('visibilitychange', onVisible);
      window.clearInterval(timer);
    };
  }, []);
}
